export default __webpack_public_path__ + "static/06.06_Partners_logo_768-5bdabbf0802ae52ec46201eae6cfbb00.png";